import { DatumLayer, LayerCollection, MapProperties } from '@datum-map';
import {
  getDataFromMapLink,
  getSearchFromHash,
  changeMapLayerHash,
  changeMapPropHash,
} from '@project/routes/utils';
import { validationMapParams } from '@project/utils/validation';
import { reaction } from 'mobx';
import { Coordinate } from 'ol/coordinate';
import { debounce } from '@datum-map/utils/other';

export class Map {
  static initHash = window.location.hash;

  static getInitData() {
    const initSearch = getSearchFromHash(this.initHash);
    const data = getDataFromMapLink(initSearch);

    if (!data) return;
    const mapData = validationMapParams(data);

    return mapData;
  }

  mapProps: MapProperties;

  constructor(prop: MapProperties, collection: LayerCollection) {
    this.mapProps = prop;
    this._setMapPropsToHash = debounce(this._setMapPropsToHash.bind(this), 500);

    reaction(() => {
      return {
        zoom: prop.zoom,
        center: prop.center,
      };
    }, this._setMapPropsToHash);

    reaction(() => collection.layers, this._setMapLayersToHash);
  }

  public initializeHash(layerCollection?: LayerCollection) {
    this._setMapPropsToHash({
      zoom: this.mapProps.zoom,
      center: this.mapProps.center,
    });

    if (layerCollection?.layers?.length) {
      this._setMapLayersToHash(layerCollection.layers);
    }
  }

  private _setMapPropsToHash(params: { zoom: number; center?: Coordinate }) {
    const { zoom, center } = params;

    if (!zoom && !center) return;

    const currentHash = window.location.hash;
    const url = changeMapPropHash(currentHash, zoom, center);
    history.pushState(null, '', `${url}`);
  }

  private _setMapLayersToHash(layers: DatumLayer[]) {
    const names = [...new Set(layers.map((layer) => layer.name).reverse())];
    const currentHash = window.location.hash;
    const url = changeMapLayerHash(currentHash, names);
    history.pushState(null, '', `${url}`);

    const remember = localStorage.getItem('rememberLayerState') === 'true';
    if (remember) {
      localStorage.setItem('selectedLayers', JSON.stringify(names));
    }
  }
}
